// Dependencies
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import * as _ from 'lodash';

// Models
import { OrganizationModel } from '../../models/organization.model';

// Interfaces
import { OrganizationSelectionI } from '../../interfaces/organization-selection.interface';

@Component({
    selector: 'language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent {
    constructor() {}

    // Bindings
    @Input() languages: Object[];
    @Input() selected: string;
    @Output() languageChanged = new EventEmitter<Object>();

    // Properties
    organizationsSelected: OrganizationSelectionI[] = [];
    organizationsSelectedIds: number[] = [];

    //---------------------------------
    // Lifecycle Hooks
    //---------------------------------

    ngOnInit() {

    }

    //---------------------------------
    // Public
    //---------------------------------

    change() {
        this.languageChanged.emit(this.selected);
    }
}


// WEBPACK FOOTER //
// ./src/app/partials/language-selector/language-selector.component.ts